/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORD_EVENT_DETAILS,
  LOAD_RECORD_EVENT_DETAILS_ERROR,
  LOAD_RECORD_EVENT_DETAILS_SUCCESS,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  CREATE_EVENT_RECORD,
  CREATE_EVENT_RECORD_SUCCESS,
  CREATE_EVENT_RECORD_ERROR,
  UPDATE_EVENT_RECORD,
  UPDATE_EVENT_RECORD_SUCCESS,
  UPDATE_EVENT_RECORD_ERROR,
  DELETE_EVENT_RECORD,
  DELETE_EVENT_RECORD_SUCCESS,
  DELETE_EVENT_RECORD_ERROR,
  LOAD_EVENT_DATE_RECORDS,
  LOAD_EVENT_DATE_RECORDS_SUCCESS,
  LOAD_EVENT_DATE_RECORDS_ERROR,

  //Offer
  CREATE_OFFER_LIST,
  CREATE_OFFER_LIST_SUCCESS,
  CREATE_OFFER_LIST_ERROR,
  LOAD_OFFER_LIST,
  LOAD_OFFER_LIST_SUCCESS,
  LOAD_OFFER_LIST_ERROR,
  LOAD_VENUE_LIST_SUCCESS,
  LOAD_VENUE_LIST,
  LOAD_VENUE_LIST_ERROR,
  LOAD_CITY_VENUE,
  LOAD_CITY_VENUE_SUCCESS,
  LOAD_CITY_VENUE_ERROR,
  ADD_VENUE_LIST,
  ADD_VENUE_LIST_SUCCESS,
  ADD_VENUE_LIST_ERROR,
  UPDATE_VENUE_LIST,
  UPDATE_VENUE_LIST_SUCCESS,
  UPDATE_VENUE_LIST_ERROR,

 //Venue Locations
 LOAD_VENUE_LOCATION_LIST,
LOAD_VENUE_LOCATION_LIST_SUCCESS,
LOAD_VENUE_LOCATION_LIST_ERROR,

ADD_VENUE_LOCATION_LIST,
ADD_VENUE_LOCATION_LIST_SUCCESS,
ADD_VENUE_LOCATION_LIST_ERROR,

UPDATE_VENUE_LOCATION_LIST,
UPDATE_VENUE_LOCATION_LIST_SUCCESS,
UPDATE_VENUE_LOCATION_LIST_ERROR,

} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

//Event date api
/**
 * @param {date} event_date
 */
export function loadEventDateRecords(event_date) {
  // alert("gg")
  console.log("event_date load event date rec", event_date)
  return {
    type: LOAD_EVENT_DATE_RECORDS,
    event_date,
  }
}

/**
 * @param {object} record
 * @param {object} recordsMetaData
 */
export function loadEventDateRecordsSuccess(event_date, success) {
  return {
    type: LOAD_EVENT_DATE_RECORDS_SUCCESS,
    event_date,
    success
  }
}

/**
 * @param {string} error
 */
export function loadEventDateRecordsError(error) {
  return {
    type: LOAD_EVENT_DATE_RECORDS_ERROR,
    error,
  }
}

/**
 * @param {integer} id
 */
export function loadRecordEventDetails(id) {
  return {
    type: LOAD_RECORD_EVENT_DETAILS,
    id,
  }
}

/**
 * @param {object} record
 * @param {object} recordsMetaData
 */
export function loadRecordEventDetailsSuccess(record_event_details) {
  return {
    type: LOAD_RECORD_EVENT_DETAILS_SUCCESS,
    record_event_details,
  }
}

/**
 * @param {string} error
 */
export function loadRecordEventDetailsError(error) {
  return {
    type: LOAD_RECORD_EVENT_DETAILS_ERROR,
    error,
  }
}

export function createEventRecord(eventUpdate) {
  console.log("record", eventUpdate)
  return {
    type: CREATE_EVENT_RECORD,
    eventUpdate,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createEventRecordSuccess(eventUpdate, success) {
  console.log("record", eventUpdate)
  return {
    type: CREATE_EVENT_RECORD_SUCCESS,
    eventUpdate,
    success,
  }
}

/**
 * @param {string} error
 */
export function createEventRecordError(error) {
  return {
    type: CREATE_EVENT_RECORD_ERROR,
    error,
  }
}

export function updateEventRecord(eventUpdate) {
  return {
    type: UPDATE_EVENT_RECORD,
    eventUpdate,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateEventRecordSuccess(eventUpdate, success) {
  return {
    type: UPDATE_EVENT_RECORD_SUCCESS,
    eventUpdate,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateEventRecordError(error) {
  return {
    type: UPDATE_EVENT_RECORD_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function deleteEventRecord(eventRemoveId) {
  console.log(eventRemoveId, "action for delete")

  return {
    type: DELETE_EVENT_RECORD,
    eventRemoveId,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteEventRecordSuccess(eventRemoveId, success) {
  return {
    type: DELETE_EVENT_RECORD_SUCCESS,
    eventRemoveId,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteEventRecordError(error) {
  return {
    type: DELETE_EVENT_RECORD_ERROR,
    error,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Offer

/**
 * @param {integer} id
 */
export function loadOfferList(offer_list) {
  return {
    type: LOAD_OFFER_LIST,
    offer_list
  }
}

/**
 * @param {object} record
 * @param {object} recordsMetaData
 */
export function loadOfferListSuccess(offer_list) {
  return {
    type: LOAD_OFFER_LIST_SUCCESS,
    offer_list,
  }
}

/**
 * @param {string} error
 */
export function loadOfferListError(error) {
  return {
    type: LOAD_OFFER_LIST_ERROR,
    error,
  }
}

export function createOfferRecord(offerList) {
  console.log("record", offerList)
  return {
    type: CREATE_OFFER_LIST,
    offerList,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createOfferRecordSuccess(offerList, success) {
  console.log("record", offerList)
  return {
    type: CREATE_OFFER_LIST_SUCCESS,
    offerList,
    success,
  }
}

/**
 * @param {string} error
 */
export function createOfferRecordError(error) {
  return {
    type: CREATE_OFFER_LIST_ERROR,
    error,
  }
}

//Venue name list
/**
 * @param {integer} id
 */
export function loadVenueList(id) {
  return {
    type: LOAD_VENUE_LIST,
    id,
  }
}

/**
 * @param {object} record
 * @param {object} recordsMetaData
 */
export function loadVenueListSuccess(venue_list) {
  return {
    type: LOAD_VENUE_LIST_SUCCESS,
    venue_list,
  }
}

/**
 * @param {string} error
 */
export function loadVenueListError(error) {
  return {
    type: LOAD_VENUE_LIST_ERROR,
    error,
  }
}

//Venue name list
/**
 * @param {integer} id
 */
export function loadCityVenueList(id) {
  return {
    type: LOAD_CITY_VENUE,
    id,
  }
}

/**
 * @param {object} record
 * @param {object} recordsMetaData
 */
export function loadCityVenueListSuccess(city_venue) {
  return {
    type: LOAD_CITY_VENUE_SUCCESS,
    city_venue,
  }
}

/**
 * @param {string} error
 */
export function loadCityVenueListError(error) {
  return {
    type: LOAD_CITY_VENUE_ERROR,
    error,
  }
}

//ADD venue list

export function addVenueList(venueData) {
  console.log("record", venueData)
  return {
    type: ADD_VENUE_LIST,
    venueData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function addVenueListSuccess(venueData, success) {
  console.log("record", venueData)
  return {
    type: ADD_VENUE_LIST_SUCCESS,
    venueData,
    success,
  }
}

/**
 * @param {string} error
 */
export function addVenueListError(error) {
  return {
    type: ADD_VENUE_LIST_ERROR,
    error,
  }
}

//Update venue list

//ADD venue list

export function updateVenueList(venueData) {
  console.log("record", venueData)
  return {
    type: UPDATE_VENUE_LIST,
    venueData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateVenueListSuccess(venueData, success) {
  console.log("record", venueData)
  return {
    type: UPDATE_VENUE_LIST_SUCCESS,
    venueData,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateVenueListError(error) {
  return {
    type: UPDATE_VENUE_LIST_ERROR,
    error,
  }
}

// Venue locations
/**
 * @param {integer} id
 */
 export function loadVenueLocations(id) {
  return {
    type: LOAD_VENUE_LOCATION_LIST,
    id,
  }
}

/**
 * @param {object} record
 * @param {object} recordsMetaData
 */
export function loadVenueLocationsSuccess(venue_locations) {
  return {
    type: LOAD_VENUE_LOCATION_LIST_SUCCESS,
    venue_locations,
  }
}

/**
 * @param {string} error
 */
export function loadVenueLocationsError(error) {
  return {
    type: LOAD_VENUE_LOCATION_LIST_ERROR,
    error,
  }
}

//ADD venue list

export function addVenueLocations(locationData) {
  console.log("record", locationData)
  return {
    type: ADD_VENUE_LOCATION_LIST,
    locationData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function addVenueLocationsSuccess(locationData, success) {
  console.log("record", locationData)
  return {
    type: ADD_VENUE_LOCATION_LIST_SUCCESS,
    locationData,
    success,
  }
}

/**
 * @param {string} error
 */
export function addVenueLocationsError(error) {
  return {
    type: ADD_VENUE_LOCATION_LIST_ERROR,
    error,
  }
}

//Update venue list

//ADD venue list

export function updateVenueLocations(locationData) {
  console.log("record", locationData)
  return {
    type: UPDATE_VENUE_LOCATION_LIST,
    locationData,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateVenueLocationsSuccess(locationData, success) {
  console.log("record", locationData)
  return {
    type: UPDATE_VENUE_LOCATION_LIST_SUCCESS,
    locationData,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateVenueLocationsError(error) {
  return {
    type: UPDATE_VENUE_LOCATION_LIST_ERROR,
    error,
  }
}


const actions = {
  loadEventDateRecords,
  loadEventDateRecordsSuccess,
  loadEventDateRecordsError,
  createEventRecord,
  createEventRecordError,
  createEventRecordSuccess,
  deleteEventRecord,
  deleteEventRecordSuccess,
  deleteEventRecordError,
  updateEventRecord,
  updateEventRecordError,
  updateEventRecordSuccess,
  loadRecordsCacheHit,
  loadRecordEventDetails,
  loadRecordEventDetailsError,
  loadRecordEventDetailsSuccess,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  //Venue
  loadVenueList,
  loadVenueListSuccess,
  loadVenueListError,
  //Venue name
  loadCityVenueList,
  loadCityVenueListSuccess,
  loadCityVenueListError,

  //Add venue
  addVenueList,
  addVenueListSuccess,
  addVenueListError,

  //Update venue
  updateVenueList,
  updateVenueListSuccess,
  updateVenueListError,

  //Venue Locations
  loadVenueLocations,
  loadVenueLocationsSuccess,
  loadVenueLocationsError,

  addVenueLocations,
  addVenueLocationsSuccess,
  addVenueLocationsError,

  updateVenueLocations,
  updateVenueLocationsSuccess,
  updateVenueLocationsError,

}

export default actions
